import { render } from "./PersonalDetails.vue?vue&type=template&id=61fcb8eb"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"
script.render = render

export default script